import {get, post} from "@/services/api";

const state = {
    seminars: [],
    seminar: {id: null, type: 'seminar', subjectId: null, date: null, title: '', owner: ''},
    goToTestFromSeminar: false,
    fromSubjectId: null
};

const getters = {
    seminars: state => state.seminars,
    seminar: state => state.seminar,
    goToTestFromSeminar: state => state.goToTestFromSeminar,
    fromSubjectId: state => state.fromSubjectId
}

const actions = {
    async fetchAllSeminars({commit},) {
        const response = await get('gamification/academic/');
        commit('setAcademics', response.data.items);
    },
    async saveSeminar({commit},{seminarRequest}){
        const response = await post('gamification/lesson/',seminarRequest)
        commit('setSeminar', response.data.content)
        return response.data.content
    },
    async fetchSeminarById({commit},{seminarId}){
        const response = await get(`gamification/lesson/${seminarId}`)
        commit('setSeminar', response.data.content)
        return response.data.content
    },
    async fetchSeminarsBySubjectId({commit}, {subjectId}){
        const response = await get(`gamification/lesson/by_subject/${subjectId}`)
        commit('setSeminars', response.data.items)
        return response.data.items
    },
    async fetchPeriodData(_, {seminarId, periodId}){
        const response = await get(`gamification/lesson/${seminarId}/period/${periodId}`)
        return response.data.content
    },
    clearSeminar({commit}){ commit('clearSeminar') },
}

const mutations = {
    setSeminars: (state, seminars) => (state.seminars = seminars),
    clearSeminar: (state) => (Object.assign(state.seminar, {id: null, type: 'seminar', subjectId: null, date: null, title: '', owner: ''})),
    setSeminar: (state, seminar) => (state.seminar = seminar),
    setGoToTestFromSeminar: (state, goTo) => (state.goToTestFromSeminar = goTo),
    setFromSubjectId: (state, id) => (state.fromSubjectId = id)
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}